import { FACT_LABEL } from './chunk-SQDVICPJ.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SubCard({ caption, meta, children, className }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: ["rounded-md border border-border/60 bg-muted/20 px-3 py-2", className].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "mb-1.5 flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: FACT_LABEL, children: caption }),
          meta != null && /* @__PURE__ */ jsx("span", { className: "ml-auto flex items-center gap-2", children: meta })
        ] }),
        children
      ]
    }
  );
}

export { SubCard };
//# sourceMappingURL=chunk-NKKE75YN.js.map
//# sourceMappingURL=chunk-NKKE75YN.js.map